import React from "react";
import RequestFeatureForm from "../components/request-feature-form";

export default () => <RequestFeatureForm />;
